import React from 'react';
import { StarIcon } from 'lucide-react';
import { AnimateOnScroll } from './AnimateOnScroll';
function SectionDivider() {
  return <div className="flex flex-col items-center mb-16" data-id="element-2128">
      <img src="https://cdn.magicpatterns.com/uploads/oCf7AFJw67JMTtU3gnEHdW/Group_169.png" alt="" className="h-auto" style={{
      width: '18px'
    }} data-id="element-2129" />
    </div>;
}
function WavyUnderline() {
  return <svg className="w-full h-2 mt-0.5" viewBox="0 0 200 8" fill="none" preserveAspectRatio="none" data-id="element-2130">
      <path d="M0,4 Q10,0 20,4 T40,4 T60,4 T80,4 T100,4 T120,4 T140,4 T160,4 T180,4 T200,4" stroke="#FF1493" strokeWidth="2.5" fill="none" data-id="element-2131" />
    </svg>;
}
export function TestimonialsSection() {
  return <section id="testimonials" className="bg-[#E8E8E8] pb-24 lg:pb-32" data-id="element-2132">
      <SectionDivider data-id="element-2133" />

      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-2134">
        {/* Header */}
        <AnimateOnScroll className="text-center mb-20" data-id="element-2135">
          <p className="font-serif italic text-base text-gray-600 mb-4" data-id="element-2136">
            (Be Real :)
          </p>
          <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-bold uppercase text-black mb-4" data-id="element-2137">
            REAL STORIES,
            <br data-id="element-2138" />
            REAL{' '}
            <span className="inline-block" data-id="element-2139">
              <span className="text-[#FF1493]" data-id="element-2140">TRANSFORMATIONS</span>
              <WavyUnderline data-id="element-2141" />
            </span>
          </h2>
          <p className="font-body text-base text-gray-600 max-w-lg mx-auto mt-6" data-id="element-2142">
            Listen to the voices of our clients, who share the transformative
            experiences and newfound confidence they've gained with Be CLINICAL
          </p>
        </AnimateOnScroll>

        {/* Testimonial Cards */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-2143">
          {/* Card 1 */}
          <AnimateOnScroll delay={0} data-id="element-2144">
            <div className="bg-white rounded-2xl shadow-md p-8 pt-14 text-center relative" data-id="element-2145">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2" data-id="element-2146">
                <img src="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?auto=format&fit=crop&q=80&w=200" alt="Jamie" className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover" data-id="element-2147" />
              </div>
              <div className="flex gap-1 justify-center mb-4" data-id="element-2148">
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2149" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2150" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2151" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2152" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2153" />
              </div>
              <p className="font-body text-sm text-gray-600 leading-relaxed italic" data-id="element-2154">
                "Jamie is the best injector I've ever had and I used to manage a
                Plastic Surgery clinic! She is a perfectionist and a great
                nurse! Her work is amazing and she knows exactly what she's
                talking about. I am so grateful to her for all she does and for
                her dedication and commitment to her profession..."
              </p>
            </div>
          </AnimateOnScroll>

          {/* Card 2 */}
          <AnimateOnScroll delay={150} data-id="element-2155">
            <div className="bg-white rounded-2xl shadow-md p-8 pt-14 text-center relative" data-id="element-2156">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2" data-id="element-2157">
                <img src="https://cdn.magicpatterns.com/uploads/iCUYtAbFG17Zca2mqiA746/Ellipse-2.png.png" alt="Client" className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover" data-id="element-2158" />
              </div>
              <div className="flex gap-1 justify-center mb-4" data-id="element-2159">
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2160" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2161" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2162" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2163" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2164" />
              </div>
              <p className="font-body text-sm text-gray-600 leading-relaxed italic" data-id="element-2165">
                "This team is amazing! Dr. Fiona Frie is not only a skin
                [genius] but truly an expert in the actual science behind what
                they do. The sheer fact that Be Clinical can actually explain
                the processes behind their treatments is exactly why I hold them
                (especially Dr. Frie) in such high regard. So if you are looking
                for..."
              </p>
            </div>
          </AnimateOnScroll>

          {/* Card 3 */}
          <AnimateOnScroll delay={300} data-id="element-2166">
            <div className="bg-white rounded-2xl shadow-md p-8 pt-14 text-center relative" data-id="element-2167">
              <div className="absolute -top-8 left-1/2 -translate-x-1/2" data-id="element-2168">
                <img src="https://cdn.magicpatterns.com/uploads/sNbem5y2M9gP1BDhS6cWAk/Ellipse-5.png.png" alt="Sarah" className="w-16 h-16 rounded-full border-4 border-white shadow-md object-cover" data-id="element-2169" />
              </div>
              <div className="flex gap-1 justify-center mb-4" data-id="element-2170">
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2171" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2172" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2173" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2174" />
                <StarIcon size={14} className="text-[#FFD700] fill-[#FFD700]" data-id="element-2175" />
              </div>
              <p className="font-body text-sm text-gray-600 leading-relaxed italic" data-id="element-2176">
                "Everyone here was so welcoming and friendly. Had an appointment
                with Leah and she was super easy going and informative regarding
                specifics on any questions I had about my treatment. Definitely
                recommend this place for not only being a good, clean
                environment with a range of services..."
              </p>
            </div>
          </AnimateOnScroll>
        </div>
      </div>
    </section>;
}